import React, { Component } from "react";
//import AxiosWidgetQuestion from "./axios.tsx";
import UserBaseUtil from "@/Utility/UserBase.js";

interface MessageState {
  type: "error" | "success" | "info" | null;
  text: string | null;
}

interface CreateEventState {
  textArea: string;
  username: string;
  isSubmitting: boolean;
  message: MessageState;
}

interface QuestionData {
  body: string;
  user: string;
  currentItem: any;
}

interface CreateEventProps {
  onClose: () => void;
  inputData: (question: QuestionData) => Promise<void>;
  currentItem: any;
}

// Placeholder for external data submission
const SendToSupabase = (text: string, username: string) => {
  console.log(`Sending to Supabase: "${text}" from user: ${username}`);
  // Simulate API delay
  return new Promise((resolve) => setTimeout(resolve, 500));
};

// Component is now typed with empty props ({}) and the defined state interface
class CreateAnswer extends Component<CreateEventProps, CreateEventState> {
  // Initialize state using the CreatePrayerState interface
  state: CreateEventState = {
    textArea: "",
    username: "GuestUser",
    isSubmitting: false,
    message: { type: null, text: null },
  };

  constructor(props: CreateEventProps) {
    super(props);
    // Bindings are necessary for class methods used as event handlers
    this.handleTextChange = this.handleTextChange.bind(this);
    this.PostData = this.PostData.bind(this);
  }

  getUserName(): string {
    return this.state.username;
  }

  // Type the event as a change event from an HTMLTextAreaElement
  handleTextChange(event: React.ChangeEvent<HTMLTextAreaElement>): void {
    this.setState({
      textArea: event.target.value,
      message: { type: null, text: null }, // Clear messages on input
    });
  }

  componentDidUpdate(prevProps: CreateEventProps) {
    if (this.props.currentItem !== prevProps.currentItem) {
      if (this.props.currentItem) {
        console.log("Current item ID changed to:", this.props.currentItem);
      }
    }
  }

  async PostData(): Promise<void> {
    const { textArea } = this.state;
    const username: string = this.getUserName();

    console.log(this.props.currentItem);
    console.log("apa sini");
    var json = {
      body: textArea,
      user: username,
      currentItem: this.props.currentItem,
    };

    var jsonaxios = {
      question: textArea,
      id: this.props.currentItem,
    };

    if (!textArea.trim()) {
      this.setState({
        message: {
          type: "error",
          text: "Please enter some text before submitting.",
        },
      });
      return;
    }

    this.setState({
      isSubmitting: true,
      message: { type: "info", text: "Submitting..." },
    });

    try {
      // await AxiosWidgetQuestion.updateQuestion(jsonaxios);
      this.props.inputData(json);
      this.setState({
        textArea: "",
        message: {
          type: "success",
          text: "Your post has been shared successfully!",
        },
      });
    } catch (error) {
      console.error("Submission failed:", error);
      this.setState({
        message: {
          type: "error",
          text: "Failed to submit post. Please try again.",
        },
      });
    } finally {
      this.setState({ isSubmitting: false });
    }

    this.props.onClose();
  }

  render() {
    const { textArea, isSubmitting, message } = this.state;

    // Determine message styling based on type
    let messageClasses = "";
    if (message.type === "error") {
      messageClasses = "bg-red-100 text-red-700 border-red-400";
    } else if (message.type === "success") {
      messageClasses = "bg-green-100 text-green-700 border-green-400";
    } else if (message.type === "info") {
      messageClasses = "bg-blue-100 text-blue-700 border-blue-400";
    }

    return (
      // Full-screen background and centering container
      <div
        className="flex items-center justify-center p-4 w-full"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Content box for the form elements */}
        <div className="w-full max-w-lg p-6 bg-white rounded-xl shadow-2xl space-y-5">
          <button
            onClick={this.props.onClose}
            className="absolute top-3 right-3 p-2 text-white hover:text-gray-700 transition duration-150 ease-in-out rounded-full hover:bg-gray-100 z-10"
            aria-label="Close form"
          >
            {/* SVG icon for a crisp 'X' */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <h2 className="text-3xl font-extrabold text-center text-gray-800">
            🙏 Write Your Answr Here
          </h2>

          {/* Message Display Area */}
          {message.text && (
            <div
              className={`p-3 text-sm font-medium rounded-lg border-l-4 ${messageClasses}`}
            >
              {message.text}
            </div>
          )}

          <textarea
            className="w-full h-48 p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-blue-500/50 transition duration-300 ease-in-out resize-none shadow-inner"
            value={textArea}
            onChange={this.handleTextChange}
            placeholder="Type your answer..."
            disabled={isSubmitting}
          />

          <button
            className="w-full py-3 bg-blue-600 text-white font-extrabold rounded-lg shadow-md hover:bg-blue-700 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-[1.01]"
            onClick={this.PostData}
            disabled={!textArea.trim() || isSubmitting} // Disable if text is empty or submitting
          >
            {isSubmitting ? "Sending..." : "Submit Answer"}
          </button>
        </div>
      </div>
    );
  }
}

export default CreateAnswer;
